export default function ProgressStepper({ currentStep = 0, labels = [] }) {
  return (
    <div className="stepper">
      {labels.map((label, index) => (
        <div key={index} className="step-container">
          {/* Circle */}
          <div
            className={`step-circle ${
              index < currentStep
                ? "completed"
                : index === currentStep
                ? "active"
                : ""
            }`}
          >
            {index < currentStep ? "✔" : index + 1}
          </div>

          {/* Label */}
          <span
            className={`step-label ${
              index <= currentStep ? "active-label" : ""
            }`}
          >
            {label}
          </span>

          {/* Connector line */}
          {index < labels.length - 1 && (
            <div className="step-line">
              <div
                className={`step-line-fill ${
                  index < currentStep ? "filled" : ""
                }`}
              ></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
